import Axios from '@/services/axios-instance/axios.service';

class UserService {
  async loginUser(req) {
    const { data } = await Axios.post('/login', req);
    return data;
  }
  async sendVerificationCode(req) {
    const { data } = await Axios.post('/send-verification-code', req);
    return data;
  }
  async registerUser(req) {
    const { data } = await Axios.post('/register', req);
    return data;
  }
  async confirmUserEmail(req) {
    const { data } = await Axios.post('/confirm-email', req);
    return data;
  }
  async forgotUserPassword(req) {
    const { data } = await Axios.post('/forgot-password', req);
    return data;
  }
  async logoutUser() {
    const { data } = await Axios.get('/logout');
    return data;
  }
}

export default new UserService();
